import { Guid } from '@/utils/guid'
import { getFormatMessage } from '@/utils/utils'
import { PlusOutlined } from '@ant-design/icons'
import { Form, Input, Modal, Tag } from 'antd'
import React, { useEffect, useState } from 'react'
import { BoxEditModalProps } from '../interface'

export const BoxEditModal: React.FC<BoxEditModalProps> = (
  props: BoxEditModalProps
) => {
  const [alias, setAlias] = useState<string>()
  const [tags, setTags] = useState<string[]>([])
  const [editTag, setEditTag] = useState<boolean>(false)
  const { visible, editItem, onVisibleChange, onFinish } = props
  const tagInputRef = React.useRef<any>(null)
  const formatMessage = getFormatMessage()

  const tagInput = {
    width: '78px',
    marginRight: '8px',
    verticalAlign: 'top'
  }

  const tagPlus = {
    background: '#fff',
    borderStyle: 'dashed'
  }

  const handleNewTagClick = () => {
    setEditTag(true)
  }

  const handleNewTagBlur = (value: string) => {
    const items = tags.concat(value)
    setTags(items)
    setEditTag(false)
  }

  const handleTagClose = (tag: string) => {
    const items = tags.filter((x) => x !== tag)
    setTags(items)
  }

  const handleModalOk = () => {
    const edit = {
      alias: alias,
      tags: tags.join(',')
    }
    onVisibleChange?.(false)
    onFinish?.(editItem!, edit)
  }

  useEffect(() => {
    if (editItem) {
      const items = editItem.tags?.split(',').filter((x) => !!x) || []
      setTags(items)
      setAlias(editItem.alias)
    } else {
      setTags([])
      setAlias(undefined)
    }
  }, [editItem])

  return (
    <Modal
      destroyOnClose={true}
      maskClosable={false}
      title={`编辑: ${editItem?.boxNo}`}
      visible={visible}
      onCancel={() => onVisibleChange?.(false)}
      onOk={handleModalOk}
    >
      <Form>
        <Form.Item label='设备别名'>
          <Input value={alias} onChange={(e) => setAlias(e.target.value)} />
        </Form.Item>
        <Form.Item label='设备标签'>
          {tags.map((x) => {
            return (
              <Tag closable onClose={(e) => handleTagClose(x)} key={Guid.raw()}>
                {x}
              </Tag>
            )
          })}

          {editTag && (
            <Input
              ref={tagInputRef}
              type='text'
              size='small'
              style={tagInput}
              onBlur={(e) => handleNewTagBlur(e.target.value)}
            />
          )}

          {!editTag && (
            <Tag style={tagPlus} onClick={handleNewTagClick}>
              <PlusOutlined />
              {formatMessage({ id: 'app.box.detail.basic.tags.add' })}
            </Tag>
          )}
        </Form.Item>
      </Form>
    </Modal>
  )
}
